import adinConfigs from '@/adin-configs'
import Vue from 'vue'

Vue.prototype.$mainConfig = adinConfigs.prod
